var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fb-group",staticStyle:{"max-width":"600px","margin":"0 auto"}},[_c('span',[_vm._v("\n          Crawler Status: "+_vm._s(_vm.crawler_status)+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n          Total crawled posts: "+_vm._s(_vm.total)+"\n      ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e81c73ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fb/group/crawl.vue
// module id = null
// module chunks = 